<template>
  <section class="section">
    <div class="container">
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <b-field>
            <b-input
              v-model="queryString"
              :placeholder="$translate('search').concat('...') | capitalize"
              type="search"
              icon="magnify"
              @keyup.native.enter="searchData()"
            ></b-input>
          </b-field>
        </div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        default-sort="user.first_name"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
        <template slot-scope="props">
          <b-table-column field="name" :label="$translate('model') | capitalize" sortable>{{
            props.row.name
          }}</b-table-column>
          <b-table-column
            field="modelImage"
            :label="$translate('image') | capitalize"
            :width="module === 'insole' ? '90px' : null"
          >
            <img
              :src="props.row.image"
              :width="module === 'insole' ? '70px' : '100px'"
              height="auto"
              style="cursor: pointer"
              @click="showImageModal(props.row.image, props.row.name)"
            />
          </b-table-column>

          <template v-if="$moduleConfiguration[module].minPel === $moduleConfiguration[module].maxPel">
            <b-table-column
              v-for="i in $moduleConfiguration[module].maxPel"
              :key="`pell${i}var`"
              :field="`pell${i}var`"
              :label="$translate(`pell${i}title`) | capitalize"
            >
              <b-tooltip :label="props.row[`pell${i}tag`]" position="is-left">
                <img :src="props.row[`pellImage${i}`]" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
          </template>
          <template v-else>
            <b-table-column width="200px" field="pellami" :label="$translate(`pellami`) | capitalize">
              <div class="pellami-container">
                <b-tooltip
                  v-for="i in props.row.pelCount"
                  :key="`pell${i}var`"
                  :label="props.row[`pell${i}tag`]"
                  position="is-left"
                >
                  <img
                    :src="props.row[`pellImage${i}`]"
                    width="50px"
                    height="auto"
                    @click="() => showImageModal(props.row[`pellImage${i}`], props.row[`pell${i}tag`])"
                  />
                </b-tooltip>
              </div>
            </b-table-column>
            <b-table-column
              v-if="$moduleConfiguration[module].modelHasRiporti"
              width="200px"
              field="riporti"
              :label="$translate(`riporti`) | capitalize"
            >
              <div class="pellami-container">
                <b-tooltip
                  v-for="i in props.row.ripCount"
                  :key="`rip${i}var`"
                  :label="props.row[`rip${i}tag`]"
                  position="is-left"
                >
                  <img
                    :src="props.row[`ripImage${i}`]"
                    width="50px"
                    height="auto"
                    @click="() => showImageModal(props.row[`ripImage${i}`], props.row[`rip${i}tag`])"
                  />
                </b-tooltip>
              </div>
            </b-table-column>
          </template>
          <template v-if="module === 'tailored'">
            <b-table-column field="fodantvar" :label="$translate('fodanttitle') | capitalize">
              <b-tooltip :label="props.row.fod1tag" position="is-left">
                <img :src="props.row.fodImage1" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
            <b-table-column field="fodposvar" :label="$translate('fodpostitle') | capitalize">
              <b-tooltip :label="props.row.fod2tag" position="is-left">
                <img :src="props.row.fodImage2" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
            <b-table-column field="battvar" :label="$translate('batttitle') | capitalize">
              <b-tooltip :label="props.row.battag" position="is-left">
                <img :src="props.row.batImage" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
            <b-table-column field="intevar" :label="$translate('intetitle') | capitalize">
              <b-tooltip :label="props.row.inttag" position="is-left">
                <img :src="props.row.intImage" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
          </template>
          <template v-if="module === 'insole'">
            <b-table-column width="160px" centered field="insoleBase" :label="$translate('insoleBaseMat') | capitalize">
              <b-tooltip :label="props.row.insoleBaseTag" position="is-left">
                <img
                  v-if="props.row.insoleBaseImage"
                  :src="props.row.insoleBaseImage"
                  width="75px"
                  height="auto"
                  @click="() => showImageModal(props.row.insoleBaseImage, props.row.insoleBaseTag)"
                />
              </b-tooltip>
            </b-table-column>
            <b-table-column
              width="160px"
              centered
              field="insoleCover"
              :label="$translate('insoleCoverMat') | capitalize"
            >
              <b-tooltip :label="props.row.insoleCoverTag" position="is-left">
                <img
                  v-if="props.row.insoleCoverImage"
                  :src="props.row.insoleCoverImage"
                  width="75px"
                  height="auto"
                  @click="() => showImageModal(props.row.insoleCoverImage, props.row.insoleCoverTag)"
                />
              </b-tooltip>
            </b-table-column>
            <b-table-column width="160px" centered field="insoleFill" :label="$translate('insoleFillMat') | capitalize">
              <b-tooltip :label="props.row.insoleFillTag" position="is-left">
                <img
                  v-if="props.row.insoleFillImage"
                  :src="props.row.insoleFillImage"
                  width="75px"
                  height="auto"
                  @click="() => showImageModal(props.row.insoleFillImage, props.row.insoleFillTag)"
                />
              </b-tooltip>
            </b-table-column>
            <b-table-column :label="$translate('thicknesses') | capitalize" centered>
              <b-button class="is-primary" @click="showThicknessesModal(props.row)">
                <b-icon icon="format-list-checkbox"></b-icon>
              </b-button>
            </b-table-column>
            <b-table-column :label="$translate('Ins_I') | capitalize" centered>
              <b-button class="is-primary" @click="showInsertsModal(props.row)">
                <b-icon icon="format-list-checkbox"></b-icon>
              </b-button>
            </b-table-column>
          </template>
          <b-table-column
            v-if="$moduleConfiguration[module].modelHasCustomSizes && module !== 'insole'"
            centered
            field="customSizes"
            :label="$translate('custom_sizes') | capitalize"
          >
            {{ props.row.sizes.min }} - {{ props.row.sizes.max }}
          </b-table-column>
          <template v-if="$moduleConfiguration[module].soles">
            <b-table-column field="sole" :label="$translate('default_sole') | capitalize">
              <b-tooltip :label="props.row.defaultSoleTag" position="is-left">
                <img :src="props.row.defaultSoleImg" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
          </template>
        </template>
      </b-table>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">
                  {{ $translate('filter') | capitalize }}
                </p>
              </header>
              <div class="card-content">
                <filter-select v-model="catalogTypeFilterInfo" @change="searchData()" />
                <filter-select v-model="shoeTypeFilterInfo" @change="searchData()" />
                <filter-select v-model="seasontagsFilterInfo" @change="searchData()" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal :active.sync="isImageModalActive" :width="640" scroll="keep">
        <div class="modal-card" style="width: auto">
          <section class="modal-card-body modal-container">
            <img :src="modalImage" />
          </section>
        </div>
      </b-modal>
      <b-modal :active.sync="isThicknessesModalActive" :width="480" scroll="keep">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $translate('thicknesses') | capitalize }}</p>
          </header>
          <section class="modal-card-body">
            <ul>
              <li v-for="tKey in thicknessKeys" :key="tKey">
                {{ $translate(tKey) | capitalize }}: {{ modalThicknesses[tKey] != null ? modalThicknesses[tKey] : 0 }}
              </li>
            </ul>
          </section>
        </div>
      </b-modal>
      <b-modal :active.sync="isInsertsModalActive" :width="480" scroll="keep">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $translate('Ins_I') | capitalize }}</p>
          </header>
          <section class="modal-card-body">
            <p v-if="!modalInserts.length">-</p>
            <ul v-else>
              <li v-for="(ins, idx) in modalInserts" :key="idx">
                {{ $translate(ins.section) | capitalize }}{{ ins.side ? ` ${ins.side.toUpperCase()}` : '' }}:
                {{ ins.label }} ({{ ins.thickness }} mm)
              </li>
            </ul>
          </section>
        </div>
      </b-modal>
    </div>
  </section>
</template>

<script>
import firebase from 'firebase'
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import filterSelect from '@/components/FilterSelect'
import materialTools from '@/helpers/mixins/materialTools'

export default {
  name: 'Mods',
  components: {
    'filter-select': filterSelect,
  },
  mixins: [permissionMixin, mainMixin, materialTools],
  props: {
    catalog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      catalogTypeFilterInfo: {
        label: 'catalogType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      shoeTypeFilterInfo: {
        label: 'shoeType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      seasontagsFilterInfo: {
        label: 'seasontags',
        options: [{ name: '*' }],
        filterValue: '*',
      },

      tableData: [],
      filteredData: [],
      loading: true,
      page: 1,
      total: 0,
      defaultSortOrder: 'desc',
      checkedRows: [],
      queryString: '',

      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      isImageModalActive: false,
      modalImage: '',
      modalTag: '',
      isThicknessesModalActive: false,
      isInsertsModalActive: false,
      modalThicknesses: {},
      modalInserts: [],
      thicknessKeys: ['heel_height', 'ball_height', 'fings_height', 'sup_col_med', 'avvolgenza_mediale'],

      tempcatalog: {},

      pells: [],
      accs: [],
      puns: [],
      mors: [],
      rips: [],
      insoleBases: [],
      insoleCovers: [],
      insoleFills: [],
      inserts: [],
      module: '',
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.catalog.type]
    },
  },
  watch: {
    tableData: function() {
      // this.updateAfterload()
    },
  },
  methods: {
    showImageModal(img, tag) {
      this.modalImage = img
      this.modalTag = tag
      this.isImageModalActive = true
    },
    showThicknessesModal(row) {
      this.modalThicknesses = row.thicknesses || {}
      this.isThicknessesModalActive = true
    },
    showInsertsModal(row) {
      this.modalInserts = row.insertsList || []
      this.isInsertsModalActive = true
    },
    updateFilters(newshoe) {
      if (
        this.catalogTypeFilterInfo.options
          .map(e => {
            return e.name
          })
          .indexOf(newshoe.catalogType) === -1
      ) {
        this.catalogTypeFilterInfo.options.push({
          name: newshoe.catalogType,
        })
      }
      if (
        this.shoeTypeFilterInfo.options
          .map(e => {
            return e.name
          })
          .indexOf(newshoe.shoeType) === -1
      ) {
        this.shoeTypeFilterInfo.options.push({
          name: newshoe.shoeType,
        })
      }
      if (
        this.seasontagsFilterInfo.options
          .map(e => {
            return e.name
          })
          .indexOf(newshoe.seasontags) === -1
      ) {
        this.seasontagsFilterInfo.options.push({
          name: newshoe.seasontags,
        })
      }
    },
    createFilters() {
      this.catalogTypeFilterInfo.options = [{ name: '*' }]
      this.shoeTypeFilterInfo.options = [{ name: '*' }]
      this.seasontagsFilterInfo.options = [{ name: '*' }]
      this.tableData.forEach(shoe => {
        if (
          this.catalogTypeFilterInfo.options
            .map(e => {
              return e.name
            })
            .indexOf(shoe.catalogType) === -1
        ) {
          this.catalogTypeFilterInfo.options.push({
            name: shoe.catalogType,
          })
        }
        if (
          this.shoeTypeFilterInfo.options
            .map(e => {
              return e.name
            })
            .indexOf(shoe.shoeType) === -1
        ) {
          this.shoeTypeFilterInfo.options.push({
            name: shoe.shoeType,
          })
        }
        if (
          this.seasontagsFilterInfo.options
            .map(e => {
              return e.name
            })
            .indexOf(shoe.seasontags) === -1
        ) {
          this.seasontagsFilterInfo.options.push({
            name: shoe.seasontags,
          })
        }
      })
    },
    searchData() {
      this.filteredData = []
      // eslint-disable-next-line no-useless-escape
      //let regexp = new RegExp(`\w*${this.queryString}\w*`, `gmi`);

      this.tableData.forEach(shoe => {
        if (
          //shoe.name.match(regexp) &&
          (this.catalogTypeFilterInfo.filterValue === '*' ||
            this.catalogTypeFilterInfo.filterValue === shoe.catalogType) &&
          (this.shoeTypeFilterInfo.filterValue === '*' || this.shoeTypeFilterInfo.filterValue === shoe.shoeType) &&
          (this.seasontagsFilterInfo.filterValue === '*' || this.seasontagsFilterInfo.filterValue === shoe.seasontags)
        ) {
          if (shoe.addingchar === undefined) {
            shoe.addingchar = []
          }
          if (shoe.addingcharfod === undefined) {
            shoe.addingcharfod = []
          }
          if (
            this.queryString == null ||
            shoe.name.toLowerCase().includes(this.queryString.toLowerCase()) ||
            shoe.addingchar
              .join(' ')
              .toLowerCase()
              .includes(this.queryString.toLowerCase()) ||
            shoe.addingcharfod
              .join(' ')
              .toLowerCase()
              .includes(this.queryString.toLowerCase())
          ) {
            this.filteredData.push(shoe)
          }
        }
      })
    },
    arrichData(doc) {
      let newmod = doc.data()
      newmod.id = doc.id
      let tempmat, tempvar
      let pelCount = 0
      let ripCount = 0
      for (let i = 0; i <= this.config.maxPel; i++) {
        let tempmat = this.pells.find(temp => temp.id === newmod[`pell${i}mat`])
        let tempvar = {}
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id == newmod[`pell${i}var`])
          if (tempvar !== undefined) {
            newmod[`pellImage${i}`] = tempvar.image
            newmod[`pell${i}tag`] = this.$translateMaterial(tempmat) + '-' + tempvar.name
            if (i > pelCount) pelCount = i
          }
        }
      }
      newmod.pelCount = pelCount

      for (let i = 0; i <= this.config.maxRip; i++) {
        let tempmat = this.rips.find(temp => temp.id === newmod[`rip${i}mat`])
        let tempvar = {}
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod[`rip${i}var`])
          if (tempvar !== undefined) {
            newmod[`ripImage${i}`] = tempvar.image
            newmod[`rip${i}tag`] = this.$translateMaterial(tempmat) + '-' + tempvar.name
            if (i > ripCount) ripCount = i
          }
        }
      }
      newmod.ripCount = ripCount

      if (this.module === 'fits') {
        this.puns.forEach(fodera => {
          tempmat = this.accs.find(temp => temp.id === fodera.material)
          if (tempmat !== undefined) {
            tempvar = tempmat.variants.find(temp => temp.id === fodera.variant)
            if (tempvar !== undefined) {
              newmod.accTags.push(this.$translateMaterial(tempmat) + '-' + tempvar.name)
            }
          }
        })
        this.allacci.forEach(allacciatura => {
          tempmat = this.allacci.find(temp => temp.id === allacciatura)
          if (tempmat !== undefined) {
            newmod.allTags.push(this.$translateMaterial(tempmat))
          }
        })
      }

      if (this.config.soles) {
        tempmat = this.soles.find(temp => temp.id === newmod.sole_default)
        if (tempmat !== undefined) {
          newmod.defaultSoleImg = tempmat.image
          newmod.defaultSoleTag = this.$translateMaterial(tempmat)
        }
      }

      if (this.module === 'tailored') {
        tempmat = this.accs.find(temp => temp.id === newmod.fodantmat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.fodantvar)
          if (tempvar !== undefined) {
            newmod.fodImage1 = tempvar.image
            newmod.fod1tag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }

        tempmat = this.accs.find(temp => temp.id === newmod.fodposmat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.fodposvar)
          if (tempvar !== undefined) {
            newmod.fodImage2 = tempvar.image
            newmod.fod2tag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }

        tempmat = this.puns.find(temp => temp.id === newmod.battmat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.battvar)
          if (tempvar !== undefined) {
            newmod.batImage = tempvar.image
            newmod.battag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }

        tempmat = this.mors.find(temp => temp.id === newmod.intemat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.intevar)
          if (tempvar !== undefined) {
            newmod.intImage = tempvar.image
            newmod.inttag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
      }

      if (this.module === 'insole') {
        tempmat = this.insoleBases.find(temp => temp.id === newmod.insoleBaseMat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.insoleBaseVar)
          if (tempvar !== undefined) {
            newmod.insoleBaseImage = tempvar.image
            newmod.insoleBaseTag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
        tempmat = this.insoleCovers.find(temp => temp.id === newmod.insoleCoverMat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.insoleCoverVar)
          if (tempvar !== undefined) {
            newmod.insoleCoverImage = tempvar.image
            newmod.insoleCoverTag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
        tempmat = this.insoleFills.find(temp => temp.id === newmod.insoleFillMat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.insoleFillVar)
          if (tempvar !== undefined) {
            newmod.insoleFillImage = tempvar.image
            newmod.insoleFillTag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
        newmod.insertsList = []
        if (newmod.inserts) {
          Object.keys(newmod.inserts)
            .sort()
            .forEach(key => {
              if (!Array.isArray(newmod.inserts[key])) return
              const side = key.endsWith('_sx') ? 'sx' : key.endsWith('_dx') ? 'dx' : ''
              const section = side ? key.slice(0, -3) : key
              newmod.inserts[key].forEach(slot => {
                if (slot.material == null || slot.variant == null) return
                const insertMat = this.inserts.find(temp => temp.id === slot.material)
                if (insertMat !== undefined) {
                  const insertVar = insertMat.variants.find(temp => temp.id === slot.variant)
                  if (insertVar !== undefined) {
                    newmod.insertsList.push({
                      section,
                      side,
                      label: this.$translateMaterial(insertMat) + '-' + insertVar.name,
                      thickness: slot.thickness,
                    })
                  }
                }
              })
            })
        }
      }

      return newmod
    },
    loadAsyncData(tempcatalog) {
      this.loading = true
      this.module = tempcatalog.type
      switch (this.module) {
        case 'tailored':
          this.loadAsyncDataTailored()
          break
        case 'fits':
          this.loadAsyncDataFits()
          break
        case 'modular':
          this.loadAsyncDataModular()
          break
        case 'insole':
          this.loadAsyncDataInsole(tempcatalog)
          break
        default:
      }
    },
    loadAsyncDataTailored(tempcatalog) {
      this.loading = true
      this.module = tempcatalog.type
      this.getMaterialsArray(['Pel', 'Acc', 'Pun', 'Mor']).then(arraysresponse => {
        this.pells = arraysresponse[0]
        this.accs = arraysresponse[1]
        this.puns = arraysresponse[2]
        this.mors = arraysresponse[3]
        const newTableData = []
        const temparray = []

        for (let element in tempcatalog.model) {
          temparray.push({ id: element })
        }

        let modelpromise = this.getAllInPromises('models', firebase.firestore.FieldPath.documentId(), temparray, 'id')
        Promise.all(modelpromise).then(modelsSnapshot => {
          modelsSnapshot.forEach(modelSnapshot => {
            modelSnapshot.forEach(modelDoc => {
              let newmod = this.arrichData(modelDoc)
              newTableData.push(newmod)
              this.updateFilters(newmod)
            })
          })
          this.tableData = newTableData
          this.filteredData = newTableData
        })
      })
    },
    loadAsyncDataFits(tempcatalog) {
      this.loading = true
      this.module = tempcatalog.type
      const materialsText = ['Pel_F', 'Acc_F', 'All_F', 'Pun_F', 'soles']
      this.getMaterialsArray(materialsText).then(arraysresponse => {
        this.pells = arraysresponse[0]
        this.accs = arraysresponse[1]
        this.allacci = arraysresponse[2]
        this.puns = arraysresponse[3]
        this.soles = arraysresponse[4]
        const newTableData = []
        const temparray = []

        for (let element in tempcatalog.model) {
          temparray.push({ id: element })
        }

        let modelpromise = this.getAllInPromises('models_F', firebase.firestore.FieldPath.documentId(), temparray, 'id')
        Promise.all(modelpromise).then(modelsSnapshot => {
          modelsSnapshot.forEach(modelSnapshot => {
            modelSnapshot.forEach(modelDoc => {
              let newmod = this.arrichData(modelDoc)
              newTableData.push(newmod)
              this.updateFilters(newmod)
            })
          })
          this.tableData = newTableData
          this.filteredData = newTableData
        })
      })
    },
    loadAsyncDataModular(tempcatalog) {
      this.loading = true
      this.module = tempcatalog.type
      const materialsText = ['Pel_M', 'Rip_M', 'soles_M']
      this.getMaterialsArray(materialsText).then(arraysresponse => {
        this.pells = arraysresponse[0]
        this.rips = arraysresponse[1]
        this.soles = arraysresponse[2]
        const newTableData = []
        const temparray = []

        for (let element in tempcatalog.model) {
          temparray.push({ id: element })
        }

        let modelpromise = this.getAllInPromises('models_M', firebase.firestore.FieldPath.documentId(), temparray, 'id')
        Promise.all(modelpromise).then(modelsSnapshot => {
          modelsSnapshot.forEach(modelSnapshot => {
            modelSnapshot.forEach(modelDoc => {
              let newmod = this.arrichData(modelDoc)
              newTableData.push(newmod)
              this.updateFilters(newmod)
            })
          })
          this.tableData = newTableData
          this.filteredData = newTableData
        })
      })
    },
    loadAsyncDataInsole(tempcatalog) {
      this.loading = true
      this.module = tempcatalog.type
      const materialsText = ['Moi_I', 'Ric_plan_I', 'Rie_plan_I', 'Ins_I']
      this.getMaterialsArray(materialsText).then(arraysresponse => {
        this.insoleBases = arraysresponse[0]
        this.insoleCovers = arraysresponse[1]
        this.insoleFills = arraysresponse[2]
        this.inserts = arraysresponse[3]
        const newTableData = []
        const temparray = []

        for (let element in tempcatalog.model) {
          temparray.push({ id: element })
        }

        let modelpromise = this.getAllInPromises('models_I', firebase.firestore.FieldPath.documentId(), temparray, 'id')
        Promise.all(modelpromise).then(modelsSnapshot => {
          modelsSnapshot.forEach(modelSnapshot => {
            modelSnapshot.forEach(modelDoc => {
              let newmod = this.arrichData(modelDoc)
              newTableData.push(newmod)
              this.updateFilters(newmod)
            })
          })
          this.tableData = newTableData
          this.filteredData = newTableData
        })
      })
    },
    resetTable() {
      this.tableData = []
      this.filteredData = []
    },
  },
}
</script>
<style scoped>
.container >>> .b-table .table th {
  font-weight: 600;
  position: sticky;
  top: 0px;
  background: white;
  z-index: 10;
}

.container >>> .b-tooltip:not([data-label='']):hover:before,
.container >>> .b-tooltip:not([data-label='']):hover:after {
  z-index: 1;
}
.container >>> .table-footer td {
  color: #bdbdbd;
}
.container >>> select {
  width: 200px;
}
.pellami-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.modal-container {
  display: flex;
  justify-content: center;
}
</style>
